import { render, staticRenderFns } from "./reminder-icon.vue?vue&type=template&id=593e48e6"
import script from "./reminder-icon.vue?vue&type=script&lang=js"
export * from "./reminder-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('593e48e6')) {
      api.createRecord('593e48e6', component.options)
    } else {
      api.reload('593e48e6', component.options)
    }
    module.hot.accept("./reminder-icon.vue?vue&type=template&id=593e48e6", function () {
      api.rerender('593e48e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/contact-activity/reminder-icon.vue"
export default component.exports